module.exports = __webpack_public_path__ + "static/media/bg.081fe936.jpg";